import axios from '../../axios'

export default {
  getTranslations: function () {
    return axios.get('translations')
  },
  getTranslation: function (culturecode) {
    return axios.get('translations/' + culturecode)
  },
  getLanguages: function () {
    return axios.get('translations/languages')
  },
  postTranslations: function (dto) {
    return axios.post('translations', dto)
  },
  getTemplate: function () {
    return axios.get('translations/template')
  },
  postNewTemplateEntry: function (dto) {
    return axios.post('translations/newentry', dto)
  },
  removeTemplateKey: function (key) {
    return axios.post('translations/removeentry', key)
  },
  getLanguagesV2: function () {
    return axios.get('languages')
  }
}



// WEBPACK FOOTER //
// ./src/services/api/LanguageService.js